(function () {
  // Only run on the homepage
  if (!document.body.classList.contains('template-index')) return;

  var STYLE = [
    '.rs-stats-counter{background-color:#fbf4e4;padding:36px 16px 44px;margin:0;box-sizing:border-box}',
    '.rs-stats-card{max-width:1100px;margin:0 auto;background:#fff;border-radius:18px;box-shadow:0 8px 28px rgba(0,0,0,.06);display:grid;grid-template-columns:repeat(4,1fr);padding:26px 8px}',
    '.rs-stat{text-align:center;padding:6px 14px;display:flex;flex-direction:column;align-items:center;min-width:0}',
    '.rs-stat + .rs-stat{border-left:1px solid #f0e6cf}',
    '.rs-stat-icon{width:46px;height:46px;border-radius:50%;background:#fdf1cf;display:flex;align-items:center;justify-content:center;margin-bottom:10px}',
    '.rs-stat-icon svg{width:22px;height:22px;stroke:#b9851a;fill:none;stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round}',
    '.rs-stat-number{font-size:40px;font-weight:800;color:#1a1a1a;line-height:1;display:flex;align-items:baseline;justify-content:center;gap:2px}',
    '.rs-stat-number .rs-suffix{font-size:26px}',
    '.rs-stat-label{margin-top:8px;font-size:13px;font-weight:600;color:#5a4f3f;line-height:1.35;max-width:190px}',
    '.rs-stats-cta{display:flex;gap:14px;justify-content:center;flex-wrap:wrap;margin-top:26px}',
    '.rs-btn{display:inline-flex;align-items:center;justify-content:center;min-height:48px;padding:0 30px;border-radius:50px;font-size:14px;font-weight:700;letter-spacing:.4px;text-transform:uppercase;text-decoration:none;border:2px solid #f3be53;color:#000 !important;transition:background .2s ease,border-color .2s ease,color .2s ease}',
    '.rs-btn-primary{background:#f3be53}',
    '.rs-btn-ghost{background:transparent}',
    '.rs-btn:hover,.rs-btn:focus,.rs-btn:active{background:#37B4A2;border-color:#37B4A2;color:#fff !important;text-decoration:none}',
    '.slider-content{position:relative}',
    '.rs-hero-cta{position:absolute;left:0;right:0;bottom:28px;z-index:6;display:flex;gap:14px;justify-content:center;flex-wrap:wrap;padding:0 16px;pointer-events:none}',
    '.rs-hero-cta .rs-btn{pointer-events:auto;box-shadow:0 6px 18px rgba(0,0,0,.25)}',
    '.rs-hero-cta .rs-btn-ghost{background:rgba(255,255,255,.92)}',
    '.rs-hero-cta .rs-btn-ghost:hover,.rs-hero-cta .rs-btn-ghost:focus,.rs-hero-cta .rs-btn-ghost:active{background:#37B4A2}',
    '@media (max-width:767px){',
      '.rs-stats-counter{padding:24px 14px 32px}',
      '.rs-stats-card{grid-template-columns:repeat(2,1fr);padding:14px 4px;row-gap:6px}',
      '.rs-stat{padding:14px 8px}',
      '.rs-stat + .rs-stat{border-left:0}',
      '.rs-stat:nth-child(even){border-left:1px solid #f0e6cf}',
      '.rs-stat:nth-child(n+3){border-top:1px solid #f0e6cf}',
      '.rs-stat-number{font-size:32px}',
      '.rs-stat-number .rs-suffix{font-size:21px}',
      '.rs-stat-label{font-size:12px}',
      '.rs-hero-cta{bottom:12px;gap:8px}',
      '.rs-hero-cta .rs-btn{min-height:40px;padding:0 16px;font-size:12px}',
    '}'
  ].join('');

  var ICON_STAR = '<svg viewBox="0 0 24 24" aria-hidden="true"><polygon points="12 2.5 14.9 8.7 21.5 9.5 16.6 14 17.9 20.6 12 17.3 6.1 20.6 7.4 14 2.5 9.5 9.1 8.7"></polygon></svg>';
  var ICON_BOX = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M21 8l-9-5-9 5v8l9 5 9-5z"></path><polyline points="3.3 7.5 12 12.5 20.7 7.5"></polyline><line x1="12" y1="22" x2="12" y2="12.5"></line></svg>';
  var ICON_CAL = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="4.5" width="18" height="16.5" rx="2"></rect><line x1="3" y1="10" x2="21" y2="10"></line><line x1="8" y1="2.5" x2="8" y2="6.5"></line><line x1="16" y1="2.5" x2="16" y2="6.5"></line></svg>';
  var ICON_TRUCK = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="1.5" y="5" width="13" height="11" rx="1.5"></rect><polygon points="14.5 9 19 9 22.5 12.5 22.5 16 14.5 16"></polygon><circle cx="6" cy="18.2" r="2"></circle><circle cx="18" cy="18.2" r="2"></circle></svg>';

  function stat(icon, target, suffix, label) {
    return '<div class="rs-stat">' +
      '<div class="rs-stat-icon">' + icon + '</div>' +
      '<div class="rs-stat-number"><span class="rs-count" data-target="' + target + '">0</span>' + (suffix ? '<span class="rs-suffix">' + suffix + '</span>' : '') + '</div>' +
      '<div class="rs-stat-label">' + label + '</div>' +
    '</div>';
  }

  var HTML = '<div class="rs-stats-counter" id="rsStatsCounter">' +
    '<div class="rs-stats-card" role="group" aria-label="R&S Sandwiches in numbers">' +
      stat(ICON_STAR, 161, '', 'Google reviews, rated 5/5') +
      stat(ICON_BOX, 6000, '+', 'Catering orders fulfilled') +
      stat(ICON_CAL, 6, '', 'Years serving Melbourne') +
      stat(ICON_TRUCK, 24, 'hr', 'Ready for next-day delivery') +
    '</div>' +
  '</div>';

  var HERO_HTML = '<div class="rs-hero-cta">' +
    '<a class="rs-btn rs-btn-primary" href="/pages/order-catering">Order Online</a>' +
    '<a class="rs-btn rs-btn-ghost open-quote-popup" href="#">Request a Quote</a>' +
  '</div>';

  var styleAdded = false;
  function injectStyle() {
    if (styleAdded) return;
    styleAdded = true;
    var styleEl = document.createElement('style');
    styleEl.textContent = STYLE;
    document.head.appendChild(styleEl);
  }

  function animateCount(node) {
    var target = parseInt(node.getAttribute('data-target'), 10);
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) { node.textContent = target.toLocaleString(); return; }
    var duration = 1500;
    var startTime = null;
    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      node.textContent = Math.floor(eased * target).toLocaleString();
      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        node.textContent = target.toLocaleString();
      }
    }
    requestAnimationFrame(step);
  }

  function startCounters(container) {
    var counts = container.querySelectorAll('.rs-count');
    counts.forEach(animateCount);
  }

  function findTrustedBySection() {
    var candidates = document.querySelectorAll('body *');
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (el.children.length === 0 && el.textContent && /TRUSTED\s*BY/i.test(el.textContent)) {
        var section = el.closest('.shopify-section');
        if (section) return section;
      }
    }
    return null;
  }

  // Any "Request a Custom Quote" link opens the quote popup (the contact page link stays as a fallback)
  function wireQuoteLinks() {
    var links = document.querySelectorAll('a');
    for (var i = 0; i < links.length; i++) {
      if (/^\s*Request a Custom Quote/i.test(links[i].textContent)) links[i].classList.add('open-quote-popup');
    }
  }

  function init() {
    wireQuoteLinks();
    injectStyle();

    // Order Online + Request a Quote sit on the hero banner
    var hero = document.querySelector('.slider-content');
    if (hero && !hero.querySelector('.rs-hero-cta')) hero.insertAdjacentHTML('beforeend', HERO_HTML);

    var trustedBySection = findTrustedBySection();
    if (!trustedBySection) return;

    trustedBySection.insertAdjacentHTML('afterend', HTML);

    var container = document.getElementById('rsStatsCounter');
    if (!container) return;

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            startCounters(container);
            observer.disconnect();
          }
        });
      }, { threshold: 0.4 });
      observer.observe(container);
    } else {
      startCounters(container);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
